import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const holesSlice = createSlice({
  name: "holes",
  initialState,
  reducers: {
    addHole(state, action) {
      state = [...state, action.payload];
      return state;
    },
    removeHole(state, action) {
      return action.payload;
    },
    /** Sets the last pos of the sink */
    updateHolePos: (state, action) => {
      const { x, y, offsetX, offsetY, rotation, index } = action.payload;
      state[index].x = x;
      state[index].y = y;
      state[index].offsetX = offsetX;
      state[index].offsetY = offsetY;
      state[index].rotation = rotation;
    },
    updateHoleGap: (state, action) => {
      const { value, index } = action.payload;
      state[index].holeGap = value;
    },
    updateHoleDimension: (state, action) => {
      const { width, height, index } = action.payload;
      state[index].width = width;
      state[index].height = height;
    },
  },
});

/** Actions */
export const {
  addHole,
  removeHole,
  updateHolePos,
  updateHoleGap,
  updateHoleDimension,
} = holesSlice.actions;

/** Selectors */
export const getHoles = (store) => store.holes;
